var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.447 4.553a1.89 1.89 0 0 0-2.671 0l-.845.845a.5.5 0 0 1-.707-.708l.845-.844a2.889 2.889 0 0 1 4.085 4.085l-.844.845a.5.5 0 1 1-.707-.707l.844-.845a1.89 1.89 0 0 0 0-2.67m-1.404 1.405a.5.5 0 0 1 0 .707l-3.378 3.378a.5.5 0 1 1-.708-.707l3.379-3.378a.5.5 0 0 1 .707 0M5.398 7.224a.5.5 0 0 1 0 .707l-.845.845a1.889 1.889 0 1 0 2.672 2.67l.843-.844a.5.5 0 0 1 .708.707l-.844.845a2.89 2.89 0 0 1-4.086-4.085l.845-.845a.5.5 0 0 1 .707 0",
    clipRule: "evenodd"
  })));
};
export { SvgLink as ReactComponent };
export default __webpack_public_path__ + "dd5a20463490bf3c08d69c9fcb231103.svg";